import { AnyFunction } from "@base/util/TypeUtil";

export class Is {
  static string(object: any): object is string {
    return typeof object === "string";
  }

  static array(object: any): object is any[] {
    return Array.isArray(object);
  }

  static boolean(value: any): value is boolean[] {
    return typeof value === "boolean";
  }

  static number(value: any): value is number {
    return typeof value === "number";
  }

  static object(value: any): value is object {
    return typeof value === "object";
  }

  static symbol(value: any): value is symbol {
    return typeof value === "symbol";
  }

  static nil(value: any): value is null | undefined {
    return value === null || value === undefined;
  }

  static plainObject(value: any): value is object {
    return Is.object(value) && Object.prototype.toString.call(value) === "[object Object]";
  }

  static regExp(value: any): value is RegExp {
    return Object.prototype.toString.call(value) === "[object RegExp]";
  }

  static date(value: any): value is Date {
    return Object.prototype.toString.call(value) === "[object Date]";
  }

  static validDate(value: any): value is Date {
    return Is.date(value) && !isNaN(value.getTime());
  }

  static error(value: any): value is Error {
    return Object.prototype.toString.call(value) === "[object Error]" || value instanceof Error;
  }

  static function(value: any): value is AnyFunction {
    return typeof value === "function";
  }

  static base64(value: any): value is string {
    const base64 = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;

    return Is.string(value) && base64.test(value);
  }

  static guid(value: any): value is string {
    const guid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    return Is.string(value) && guid.test(value);
  }

  static infinity(value: any): value is number {
    return value === Infinity || value === -Infinity;
  }
}
